import { Vue } from 'vue-class-component';
import Bowser from 'bowser';
import { DealType } from '@/types/writeup';
import { Inject, Watch } from 'vue-property-decorator';
import type { VueI18n } from 'vue-i18n';
import { DealTypeSelectorClass, DealTypeSelectorProps } from './types';
import { dealTypeSelectorTemplate } from './template';

export class DealTypeSelector extends Vue.with(DealTypeSelectorProps) implements DealTypeSelectorClass {
	@Inject() readonly i18n!: VueI18n;

	observer: IntersectionObserver | undefined;

	sticked = false;

	type = this.active;

	mounted() {
		if (this.staticBar) { return; }

		const browser = Bowser.getParser(window.navigator.userAgent);
		const platform = browser.parse();

		// Safari on iOS 12 has an issue with unstable position of fixed elements on scrolling
		// Possible fix is to disable iOS style scrolling -webkit-overflow-scrolling: touch,
		// that is also hide scroll bar on iOS 12 and it is affect UX more
		// So progressive enhancement is more appropriate here
		if (platform.getOSName() === 'iOS' && platform.getOSVersion().indexOf('12') !== -1) { return; }

		this.observer = new IntersectionObserver(
			([e]) => {
				this.sticked = !e.isIntersecting;
			},
			{ threshold: [0] }
		);
		this.observer.observe(this.$refs.element as Element);
	}

	@Watch('active')
	updateType(type: DealType) {
		this.type = type;
	}

	beforeUnmount() {
		if (this.observer) {
			this.observer.unobserve(this.$refs.element as Element);
		}
	}

	getValueString(type: string, value: number | undefined) {
		if (value) {
			return this.i18n.t(`dealTypeSelector.${type}Value`, { value: this.i18n.n(value, 'currency') });
		}

		return this.i18n.t('dealTypeSelector.valuePlaceholder');
	}

	handleTypeChange(type: DealType) {
		if (type === this.type) { return; }
		this.updateType(type);
		this.onTypeChange(type);
	}

	render(): JSX.Element {
		return dealTypeSelectorTemplate(this);
	}
}
